import React, { useState } from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import { mainTable } from "../css/Common"; 
import TextArea from "../ReusableComponents/TextArea"; // Make sure this exists and is correctly implemented
import { ReceiptView } from "../components/HeaderAttribute";
import GridPage from "../components/GridPage";
const ReceiptPopup = ({ data, data1 }) => {
  const cancel = () => {};

 
  return (
    <div class="w-full p-5">
      <div class=" border-black  "></div>
      <GridPage
        title={`Receipts > ${data.ReceiptNo} > ${data.FormattedDate}`}
        header={ReceiptView}
        records={data1}
        addView={true}
        tableHeight="h-60 overflow-y-auto"
      />
    </div>
  );
};

export default ReceiptPopup;
